// extracted by mini-css-extract-plugin
export default {"name":"header_name__E7FFa"};